import "./MentionedVideos.css";
import { Carousel } from "@ui/molecules/Carousel/Carousel";
import { For } from "solid-js";
import type { PlayVideoMentionsHandler } from "../utils/videoMentionPlayback.ts";
import { MentionedVideoThumbnail } from "./MentionedVideoThumbnail.tsx";
import type { MentionedVideoItem } from "./VideoMention.tsx";

type MentionedVideosProps = {
	videoMentions: MentionedVideoItem[];
	allVideoMentions?: MentionedVideoItem[];
	appEmbedded: boolean;
	offersClipboard?: boolean;
	onPlayVideoMentions?: PlayVideoMentionsHandler;
};

export const MentionedVideos = (props: MentionedVideosProps) => {
	return (
		<Carousel
			class="mentioned-videos"
			scrollMode={props.appEmbedded ? "mousewheel" : "buttons"}
			layout="standard"
		>
			<For each={props.videoMentions}>
				{(videoMention) => (
					<div class="mentioned-video-slide">
						<MentionedVideoThumbnail
							videoMention={videoMention}
							allVideoMentions={props.allVideoMentions ?? props.videoMentions}
							appEmbedded={props.appEmbedded}
							offersClipboard={props.offersClipboard}
							onPlayVideoMentions={props.onPlayVideoMentions}
							variant="carousel"
						/>
					</div>
				)}
			</For>
		</Carousel>
	);
};
